import {InjectionToken} from "@angular/core"
import type {CmLogger} from "@cm/log"

/**
 * Injection tokens for domain-specific loggers.
 * Each token provides a CmLogger instance configured for its specific domain.
 */

export const CM_LOGGER_API = new InjectionToken<CmLogger>("cm.logger.api")
export const CM_LOGGER_APP = new InjectionToken<CmLogger>("cm.logger.app")
export const CM_LOGGER_AR = new InjectionToken<CmLogger>("cm.logger.ar")
export const CM_LOGGER_AUTH = new InjectionToken<CmLogger>("cm.logger.auth")
export const CM_LOGGER_ROUTING = new InjectionToken<CmLogger>("cm.logger.routing")
export const CM_LOGGER_RENDERING = new InjectionToken<CmLogger>("cm.logger.rendering")
export const CM_LOGGER_WORKERS = new InjectionToken<CmLogger>("cm.logger.workers")
export const CM_LOGGER_WEBASSEMBLY = new InjectionToken<CmLogger>("cm.logger.webassembly")
export const CM_LOGGER_SCANNING = new InjectionToken<CmLogger>("cm.logger.scanning")
export const CM_LOGGER_SCENE = new InjectionToken<CmLogger>("cm.logger.scene")
export const CM_LOGGER_TEMPLATES = new InjectionToken<CmLogger>("cm.logger.templates")
export const CM_LOGGER_MATERIALS = new InjectionToken<CmLogger>("cm.logger.materials")
export const CM_LOGGER_PICTURES = new InjectionToken<CmLogger>("cm.logger.pictures")
export const CM_LOGGER_TEXTURES = new InjectionToken<CmLogger>("cm.logger.textures")
export const CM_LOGGER_GRAPH = new InjectionToken<CmLogger>("cm.logger.graph")
export const CM_LOGGER_CONFIG = new InjectionToken<CmLogger>("cm.logger.config")
export const CM_LOGGER_UPLOAD = new InjectionToken<CmLogger>("cm.logger.upload")
export const CM_LOGGER_JOBS = new InjectionToken<CmLogger>("cm.logger.jobs")
